import { render } from "./AddCreditsModal.vue?vue&type=template&id=5815bcb2"
import script from "./AddCreditsModal.vue?vue&type=script&lang=js"
export * from "./AddCreditsModal.vue?vue&type=script&lang=js"

import "./AddCreditsModal.vue?vue&type=style&index=0&id=5815bcb2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__